const actions = {
    SET_LANGUAGE: 'SET_APP_LANGUAGE',
    APP_CHANGE_LANGUAGE: 'APP_CHANGE_LANGUAGE',
    onChangeLanguage: payload => ({
        type: actions.APP_CHANGE_LANGUAGE,
        payload,
    }),
}

export default actions